import React, {Fragment, useEffect, useRef, useState} from "react";
import * as ReactDOM from 'react-dom';
import {Badge, Button, Card, CardBody, Col, FormGroup, Input, Label} from "reactstrap";
import Select from "react-select";
import JqxTable from "../../../../share-components/table/JqxTable";
import {toast} from "react-toastify";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import {useDispatch, useSelector} from "react-redux";
import {updateInventory} from "../../store/inventorySlice";


const VariationInventoryJqx = (props) => {
    const {productId, sizes, variants, isThirdPartySeller} = props;
    const dispatch = useDispatch();
    let gridRef = useRef();
    let selectRef = useRef(null);
    const [variationData, setVariationData] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const currentUser = useSelector(({authReducer}) => authReducer.data.user);
    const hasEditPermission = (currentUser.permission).includes('Edit Inventory');
    //const roleRegister = register("role", { required: true });
    // Location wise rows: 'primary' (editable), 'location' (other location, read-only), 'all_locations' (read-only total)
    const hasOtherLocations = variants.some(variant => variant.locations && variant.locations.length > 0);
    const isReadOnlyRow = (rowData) => rowData && (rowData.row_type === 'location' || rowData.row_type === 'all_locations');
    const readOnlyRowClass = (row, columnfield, value, rowData) => isReadOnlyRow(rowData) ? 'rowColor' : '';

    let datafields = [
        {name: 'id', type: 'id'},
        {name: 'colour_id', type: 'id'},
        {name: 'colour_name', type: 'string'},
        {name: 'row_type', type: 'string'},
        {name: 'location', type: 'string'},
        {name:'pack_for_single',type: 'number'}

    ];

    let columns = [
        {datafield: 'id', hidden: true},
        {datafield: 'colour_id', hidden: true},
        {datafield: 'row_type', hidden: true},
        {datafield: 'pack_for_single', hidden: true},
        {
            text: 'Colour',
            datafield: 'colour_name',
            editable: false,
            columntype: 'text',
            width: hasOtherLocations ? '25%' : '50%',
            cellclassname: readOnlyRowClass,

        },
        {
            text: 'Location',
            datafield: 'location',
            editable: false,
            columntype: 'text',
            width: '25%',
            hidden: !hasOtherLocations,
            cellclassname: readOnlyRowClass,
        }];

    sizes.map((item, key) => {
        datafields.push({
            name: item.id,
            type: 'string'
        });
        columns.push({
            text: item.name,
            datafield: item.id,
            width: (50 / sizes.length) + '%',
            editable: hasEditPermission,
            columntype: 'text',
            cellclassname: readOnlyRowClass,
            // Only the primary location can be edited
            cellbeginedit: function (row) {
                return hasEditPermission && !isReadOnlyRow(variationData[row]);
            },
        })
    })

    // Primary location qty + every other location, per size
    const allLocationsRow = (primaryRow, locations) => {
        let row = {colour_id: primaryRow.colour_id, colour_name: primaryRow.colour_name, row_type: 'all_locations', location: 'All locations'};
        sizes.forEach(size => {
            row[size.id] = Number(primaryRow[size.id] || 0)
                + locations.reduce((sum, location) => sum + Number(location[size.id] || 0), 0);
        });
        return row;
    };

    useEffect(() => {
        let rows = [];
        variants.forEach(variant => {
            const locations = variant.locations || [];
            const primaryRow = {
                ...variant,
                row_type: 'primary',
                location: locations.length > 0 ? (variant.primary_location_name || 'Primary location') + ' (Primary)' : '',
            };
            rows.push(primaryRow);
            if (locations.length > 0) {
                locations.forEach(location => {
                    let locationRow = {colour_id: variant.colour_id, colour_name: variant.colour_name, row_type: 'location', location: location.location_name};
                    sizes.forEach(size => {
                        locationRow[size.id] = Number(location[size.id] || 0);
                    });
                    rows.push(locationRow);
                });
                rows.push(allLocationsRow(primaryRow, locations));
            }
        });
        setVariationData(rows);
    }, [variants])

    // Keep the colour's "All locations" row in step with its edited primary row
    const updateAllLocationsRow = (rowIndex) => {
        const primaryRow = gridRef.getrowdata(rowIndex);
        if (!primaryRow || primaryRow.row_type !== 'primary') return;
        const variant = variants.find(item => item.colour_id == primaryRow.colour_id);
        const locations = variant && variant.locations ? variant.locations : [];
        if (locations.length === 0) return;

        const allRowIndex = rowIndex + locations.length + 1;
        const row = allLocationsRow(primaryRow, locations);
        sizes.forEach(size => {
            gridRef.setcellvalue(allRowIndex, size.id, row[size.id]);
        });
    };

    const getJqxRef = jqx => {
        if (jqx) {
            gridRef = jqx;

            setTimeout(
                () => {
                    if (gridRef) {
                        const myEle = document.getElementById(gridRef._id);
                        if (myEle) {
                            gridRef.updatebounddata();
                        }
                    }

                    // myGrid.updatebounddata();
                },
                1000
            );
        }
    };


    const cellEdit = event => {
        // setDataToHookForm();
        setTimeout(() => updateAllLocationsRow(event.args.rowindex), 100);
        if (event.args.datafield == 'name') {
            // trigger('color');
        }
    };
    const inventoryUpdateSubmit = () => {
        // Only the primary location rows are saved; other locations are read-only
        const data = setDataToHookForm().filter(row => !isReadOnlyRow(row));
        setButtonDisable(true);
        const params = {id: productId, variation: {variation: data}};

        dispatch(updateInventory({...params}))
            .unwrap()
            .then(() => {
                setButtonDisable(false);
            })
            .catch(() => {
                setButtonDisable(false);
            });
    }


    const setDataToHookForm = () => {

        let variantData = [];
        const gridInformation = gridRef.getdatainformation();
        for (let i = 0; i < gridInformation.rowscount; i++) {
            const rowData = gridRef.getrowdata(i);
                variantData.push(rowData);

        }
        setVariationData(variantData);
        return variantData;

    }


    return (
        <Fragment>
            {variationData.length >0 &&   <>
                <div className="form-row mb-3">
                    <Col md="12">
                        <div style={{width: '100%'}}>
                            <JqxTable
                                datafields={datafields}
                                columns={columns}
                                data={variationData}
                                myGrid={gridRef}
                                getJqxRef={getJqxRef}
                                isDelete={false}
                                onCellendedit={cellEdit}
                                disableCreateRow
                            />
                        </div>
                    </Col>
                </div>
                {(currentUser.permission).includes('Create Inventory Item') ?
                <div className="form-row mb-3">
                    <Col md="12">
                        <ButtonLoader className={'pull-right'} disabled={buttonDisable}  onClick={inventoryUpdateSubmit} color="primary"  	type="button"  btntext="Save & Publish"></ButtonLoader>

                    </Col>
                </div>
                    :''}
            </>}
        </Fragment>
    );
}
// function areEqual(prevProps, nextProps) {
//     return JSON.stringify(prevProps.getValues) == JSON.stringify(nextProps.getValues);
//     /*
//     return true if passing nextProps to render would return
//     the same result as passing prevProps to render,
//     otherwise return false
//     */
// }
export default VariationInventoryJqx;